import { render, staticRenderFns } from "./Fishing.vue?vue&type=template&id=d6e0d412&scoped=true&"
import script from "./Fishing.vue?vue&type=script&lang=js&"
export * from "./Fishing.vue?vue&type=script&lang=js&"
import style0 from "./Fishing.vue?vue&type=style&index=0&id=d6e0d412&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e0d412",
  null
  
)

export default component.exports